import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { TopNav } from "./TopNav";
import { useBreakpoint } from "@/hooks/use-mobile";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { UnifiedFloatingChat } from "@/components/floating-chat/UnifiedFloatingChat";
import { BugReportButton } from "@/components/bug-report/BugReportButton";
import { TaskNotificationListener } from "@/components/tasks/TaskNotificationListener";

export function MainLayout() {
  const breakpoint = useBreakpoint();
  const isMobile = breakpoint === "mobile";
  const isTablet = breakpoint === "tablet";

  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  // Auto-collapse sidebar on tablet
  useEffect(() => {
    if (isTablet) {
      setSidebarCollapsed(true);
    }
  }, [isTablet]);

  // Close mobile drawer on route change (handled by Sidebar)
  const handleCloseMobile = () => setMobileOpen(false);

  if (isMobile) {
    return (
      <div className="min-h-screen bg-[#F8FAFC] safe-area-top safe-area-bottom">
        {/* Mobile Top Nav with menu trigger */}
        <TopNav onMenuClick={() => setMobileOpen(true)} showMenuButton />

        {/* Mobile Sidebar Drawer */}
        <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
          <SheetContent side="left" className="p-0 w-[280px] sm:w-72">
            <Sidebar
              collapsed={false}
              onToggle={() => {}}
              onNavigate={handleCloseMobile}
              isMobile
            />
          </SheetContent>
        </Sheet>

        {/* Page content */}
        <main className="p-3 sm:p-4 pb-24">
          <Outlet />
        </main>

        <BugReportButton />
        <UnifiedFloatingChat />
        <TaskNotificationListener />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      {/* Desktop/Tablet Sidebar */}
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
      />

      {/* Main content area */}
      <div
        className={`transition-all duration-300 ${
          sidebarCollapsed ? "ml-16" : "ml-64"
        }`}
      >
        {/* Top navigation */}
        <TopNav />

        {/* Page content with responsive padding */}
        <main className="p-4 sm:p-6 md:p-8">
          <Outlet />
        </main>
      </div>

      <BugReportButton sidebarWidth={sidebarCollapsed ? 64 : 256} />
      <UnifiedFloatingChat />
      <TaskNotificationListener />
    </div>
  );
}
